export default function EmailIcon() {
  return (
    <svg
      data-testid="email_icon"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="6" fill="#E0F1FE" />
      <path
        d="M8.5 12.666L15.0755 17.0497C15.6353 17.4229 16.3647 17.4229 16.9245 17.0497L23.5 12.666M10.1667 21.8327H21.8333C22.7538 21.8327 23.5 21.0865 23.5 20.166V11.8327C23.5 10.9122 22.7538 10.166 21.8333 10.166H10.1667C9.24619 10.166 8.5 10.9122 8.5 11.8327V20.166C8.5 21.0865 9.24619 21.8327 10.1667 21.8327Z"
        stroke="#374151"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
